import React, { Component } from 'react';
import Sound from './arrivednotification.mp3';

export class KioskTouchSound extends Component {
  constructor() {
    super();
    this.state = {
      name: 'React'
    };
  }

  render() {
    return <audio id="curbSound" src={Sound} />;
  }
}

export default KioskTouchSound;



// WEBPACK FOOTER //
// ./src/components/console/notificationsound.js